import transcriptionService from "../../../api/transcriptionService";
import { ActionTypes as action } from "./action-types";

const actions = {
  async createDocuments({ commit }, data) {
    const result = await transcriptionService.createDocument(data);
    return result;
  },
  async deleteTranscription({ commit }, meetingId) {
    const result = await transcriptionService.deleteTranscription(meetingId);
    return result;
  },
  async resetTranscription({ commit }, data) {
    const result = await transcriptionService.resetTranscription(data);
    return result;
  },
  resetState({ commit }) {
    commit(action.RESET_STATE);
},
};

export default actions;
